import { notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { siteContext } from "../server/site.server";
import { platformPageResponse } from "./page-response";
import {
  leagueOtpPage,
  membershipCreatorPage,
  useCasePage,
  useCasesIndex,
} from "./use-cases.server";

/** /use-cases, on Drate's own host only; a creator's site answers it with its own 404. */
export const loadUseCases = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  if (drate.creator) return null;
  platformPageResponse(drate);
  return useCasesIndex(drate);
});

/** One template's page (/use-cases/<slug>), on Drate's own host only. */
export const loadUseCase = createServerFn({ method: "GET" })
  .validator((slug: unknown) => {
    if (typeof slug !== "string" || !/^[a-z0-9-]{1,80}$/.test(slug)) throw notFound();
    return slug;
  })
  .handler(async ({ data: slug, context }) => {
    const drate = await siteContext(context);
    if (drate.creator) return null;
    platformPageResponse(drate);
    return useCasePage(drate, slug);
  });

/** The League OTP Bible template's own page, on Drate's own host only. */
export const loadLeagueOtp = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  if (drate.creator) return null;
  platformPageResponse(drate);
  return leagueOtpPage(drate);
});

/** The Membership creator template's own page, on Drate's own host only. */
export const loadMembershipCreator = createServerFn({ method: "GET" }).handler(
  async ({ context }) => {
    const drate = await siteContext(context);
    if (drate.creator) return null;
    platformPageResponse(drate);
    return membershipCreatorPage(drate);
  },
);
